import { Component, Input } from '@angular/core'

@Component({
  selector: 'hs-applied-filter-counts',
  templateUrl: './applied-filter-counts.component.html',
  styleUrls: ['./applied-filter-counts.component.scss'],
})
export class AppliedFilterCountsComponent {
  isFilterCountPositive = false
  _filterCount = 0

  @Input() set filterCount(value: number) {
    this._filterCount = value
    this.isFilterCountPositive = value !== null && value > 0
  }
}
